import styled, { css } from 'styled-components'

import { Button } from 'components/Button'
import { Toggle } from 'components/Toggle'

import { Color, MediaBreakpoint } from 'root-constants'

import { MOBILE_CONTENT_WIDTH } from './constants'

export const narrowContentStyles = css`
  width: 100%;
  max-width: ${MOBILE_CONTENT_WIDTH};
  margin: 0 auto;
`

export const bodyTextStyles = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${Color.INK_LIGHT};
`

export const sectionTitleStyles = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${Color.INK_DARKEST};
`

const buttonBaseStyles = css`
  width: 100%;
  max-height: 48px;

  border-radius: 48px;

  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
`

export const centeredRightControlStyles = css`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`

export const summaryRightControlStyles = css`
  position: absolute;
  top: 20px;
  right: 16px;
`

export const PrimaryButton = styled(Button)`
  ${buttonBaseStyles}

  background: ${Color.INK_DARKEST};
  color: ${Color.GOLD_LIGHTER};

  @media (min-width: ${MediaBreakpoint.LAPTOP}px) {
    width: 180px;
    flex-shrink: 0;
  }
`

export const SecondaryButton = styled(Button)`
  ${buttonBaseStyles}

  border: 1px solid rgba(9, 10, 10, 0.18);
  background: ${Color.WHITE};
  color: ${Color.INK_DARKEST};
`

export const ConsentToggle = styled(Toggle)`
  ${summaryRightControlStyles}

  width: 44px;
  height: 24px;

  span {
    background: ${Color.SKY_LIGHT};
  }

  input:checked + span {
    background: ${Color.GOLD_BASE};
  }

  span::after {
    top: 2px;
    left: 2px;

    width: 20px;
    height: 20px;

    box-shadow: none;
  }

  input:checked + span::after {
    transform: translateX(20px);
  }
`
